function sampleBtn(event, variant, index) {
  const sample = event.target.closest(".sample-product");
  const variantExists = sample.classList.contains("sample-in-cart");
  const loader = document.querySelector("#loader");

  const min = Number(sample.closest(".lt-samples-div")?.dataset.min) ?? 1

  // Show loader
  loader.style.display = "block";

  let formData = {};
  let url = "";

  if (variantExists) {
    // Prepare formData for removing the item
    // formData = {
    //   line: index,
    //   quantity: 0, // Setting quantity to 0 will remove the item
    //   sections: prepareSectionsToUpdate(),
    //   sections_url: window.location.pathname,
    // };
    // url = `${window.location.pathname}/change.js`;
  } else {
    // Prepare formData for adding the item
    formData = {
      items: [
        {
          id: variant,
          quantity: 1,
          properties: {
            _sample_min: min
          }
        },
      ],
      sections: prepareSectionsToUpdate(),
      sections_url: window.location.pathname,
    };
    url = `${window.location.pathname}/add.js`;
  }

  // Unified fetch operation
  updateCart(url, formData, getSectionsToRender()).finally(() => {
    loader.style.display = "none"; // Hide loader in finally to ensure it's always executed
  });
}

function getSectionsToRender() {
  return [
    {
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id, // Ensure this matches how your data attributes are set
      selector: "#main-cart-items",
    },
    {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer").dataset.id, // Ensure this matches how your data attributes are set
      selector: "#main-cart-footer",
    },
    {
      id: "cart-icon-bubble",
      section: document.getElementById("cart-icon-bubble").dataset.id,
      selector: "#cart-icon-bubble",
    },
  ];
}

function prepareSectionsToUpdate() {
  const sections = getSectionsToRender();
  // Extract the 'id' from each section, not the 'section' property used for Shopify's section IDs
  const sectionIds = sections.map((section) => section.section).join(",");
  return sectionIds;
}

function updateCart(url, formData, sectionsToRender) {
  let checkoutBtn = document.querySelector("button[type='submit'][id='checkout']")
  if(!!checkoutBtn) checkoutBtn.setAttribute("disabled", "disabled")

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      console.log("updating sections");
      sectionsToRender.forEach(({ section, selector }) => {
        if (data.sections && data.sections[section]) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(
            data.sections[section],
            "text/html"
          );
          const newContent = doc.querySelector(selector);
          console.log("updating section", newContent);

          const currentContent = document.querySelector(selector);
          if (currentContent && newContent) {
            currentContent.outerHTML = newContent.outerHTML;
          } else {
          }
        }
      });
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function setupObserver() {
  const parentNode = document.querySelector("body"); // Broad observation scope
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      Array.from(mutation.addedNodes).forEach((node) => {
        // Check if the node is an element node before calling querySelector
        if (node.nodeType === Node.ELEMENT_NODE) {
          const ltCartSamples =
            node.id === "lt-cart-samples"
              ? node
              : node.querySelector("#lt-cart-samples");

          const ltCartCarousel =
            node.id === "lt-cart-product-carousel"
              ? node
              : node.querySelector("#lt-cart-product-carousel");

          if (ltCartSamples || ltCartCarousel) {
            console.log("sample slider found");
            // Your SplideJS initialization logic here
            initializeCartBlocks(); // Call to a function that initializes the slider

            // Consider checking if the slider is already initialized before re-initializing
          }
        }
      });
    });
  });

  if (parentNode) {
    observer.observe(parentNode, config);
  } else {
    console.error("The parent node for observing mutations does not exist.");
  }
}

// Fallback: Listen for a Shopify-specific cart update event (example, adjust as needed)
document.addEventListener("shopify:cart:update", () => {
  initializeCartBlocks(); // Assuming Shopify triggers such an event; adjust based on actual events
});

function initializeCartBlocks() {
    try {
        if (
            document.querySelector("#lt-cart-samples .splide") ||
            document.querySelector("#lt-cart-product-carousel .splide") ||
            !!!document.querySelector("#lt-cart-samples") ||
            !!!document.querySelector("#lt-cart-product-carousel")

          ) {
            return; // Prevent reinitialization if the slider is already set up
          }

          // Updates the bar width whenever the carousel moves:

          let lts_splide = new Splide("#lt-cart-samples").mount();
          let ltpc_splide = new Splide("#lt-cart-product-carousel").mount();
    } catch (error) {
        console.error("Error initializing the slider", error);
    }
}

function setGiftMsg() {
    const giftMsgDetail = document.querySelector("#gift-wrap-message");
    const giftMsgAgree = document.querySelector("#CartGiftWrapAgree");
    const giftNote = document.querySelector("#GiftNote");
    const giftBoxAgree = document.querySelector("#CartGiftBoxAgree");

    if(!!giftMsgDetail || !!giftMsgAgree || !!giftNote) {
        giftMsgAgree.addEventListener("change", async function () {
            const attributes = {};
            const formId = giftMsgAgree.getAttribute("form");
            if (giftMsgAgree.checked) {
                giftMsgDetail.setAttribute("open", "");
                attributes['gift-wrapping'] = 'on';
                attributes['Gift Note'] = giftNote.value;
                giftNote.setAttribute("form", formId);
            } else {
                giftMsgDetail.removeAttribute("open");
                attributes['gift-wrapping'] = '';
                attributes['Gift Note'] = '';
                giftNote.removeAttribute("form");
            }

            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes })
            })
        });
    }

    !!giftBoxAgree && giftBoxAgree.addEventListener("change", async function () {
        let checkoutBtn = document.querySelector("button[type='submit'][id='checkout']")
        if(!!checkoutBtn) checkoutBtn.setAttribute("disabled", "disabled")

        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: {'gift-box': giftBoxAgree.checked ? 'on' : '' }})
        })
    });
}

function setGiftNote() {
    const charCount = () => {
      const note = document.getElementById("GiftNote");
      const msg = document.getElementById("msg");
      if(!!!note || !!!msg)
        return;

      const textEntered = note.value;
      const counter = note.maxLength - textEntered.length;
      msg.textContent = counter + " characters left";
    }

    var el = document.getElementById("GiftNote");
    !!el && el.addEventListener("keyup", charCount, false);
}

if (!customElements.get('cart-samples-validator')) {
    class CartSamplesValidator extends HTMLElement {
        connectedCallback() {
            this.min = Number(this.dataset.min || '0')
            this.cartDrawer = document.querySelector('cart-drawer')
            this._onCartUpdated = () => this.validateSamples()
            document.addEventListener('cart-drawer-items:updated', this._onCartUpdated)
            this.validateSamples()
        }

        disconnectedCallback() {
            document.removeEventListener('cart-drawer-items:updated', this._onCartUpdated)
        }

        async validateSamples() {
            let cart = {}
            try {
                let res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
                if (res.ok) cart = await res.json()
            } catch(e) { return }

            if (cart.total_price === 0 && cart.item_count > 0) {
                this.disableCheckout()
            }

            let subtotal = (cart.items_subtotal_price || 0) / 100
            if (subtotal >= this.min) return

            let sampleItems = (cart.items || []).filter(item =>
                item.properties && Number(item.properties._sample_min) === this.min
            )
            if (sampleItems.length === 0) return

            this.showOverlay()
            this.disableCheckout()

            try {
                let updates = {}
                sampleItems.forEach(item => { updates[item.key] = 0 })

                let sections = this.cartDrawer
                    ? this.cartDrawer.getSectionsToRender().map(s => s.section)
                    : []

                let res = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates, sections, sections_url: window.location.pathname })
                })

                if (!res.ok) return

                let parsedState = await res.json()

                if (this.cartDrawer && sections.length > 0 && parsedState.sections) {
                    this.cartDrawer.getSectionsToRender().forEach((section) => {
                        if (!parsedState.sections[section.section]) return
                        const parser = new DOMParser()
                        const newEl = parser.parseFromString(parsedState.sections[section.section], 'text/html').querySelector(section.selector)
                        const currentEl = document.querySelector(section.selector) || document.getElementById(section.id)
                        if (currentEl && newEl) currentEl.outerHTML = newEl.outerHTML
                    })
                }
            } catch(e) {
                console.error('Error removing samples:', e)
                this.enableCheckout()
            } finally {
                this.hideOverlay()
            }
        }

        showOverlay() {
            if (document.getElementById('cart-samples-overlay')) return
            let target = document.getElementById('main-cart-items')?.parentElement
            if (!target) return
            target.style.position = 'relative'
            let overlay = document.createElement('div')
            overlay.id = 'cart-samples-overlay'
            overlay.className = 'loader-background'
            overlay.style.display = 'block'
            let loaderRef = document.querySelector('#loader')
            overlay.innerHTML = loaderRef ? loaderRef.innerHTML : '<div class="loader"></div>'
            target.appendChild(overlay)
        }

        hideOverlay() {
            document.getElementById('cart-samples-overlay')?.remove()
        }

        disableCheckout() {
            document.querySelectorAll('button[name="checkout"]').forEach(btn => btn.setAttribute('disabled', 'disabled'))
        }

        enableCheckout() {
            document.querySelectorAll('button[name="checkout"]').forEach(btn => btn.removeAttribute('disabled'))
        }
    }
    customElements.define('cart-samples-validator', CartSamplesValidator)
}

// Initial setup call
setupObserver();

document.addEventListener("DOMContentLoaded", () => {
  // Call the function to initialize the slider
  initializeCartBlocks();
  setGiftMsg();
  setGiftNote();
});

document.addEventListener("scroll", (event) => {
  // Get the elements
  const ctaElement = document.querySelector(".cart__ctas");
  const positioner = document.getElementById("sticky-checkout-container");

  // Callback function
  const checkoutBtnCallback = (entries) => {
    entries.forEach((entry) => {
      const isBottomVisible =
        entry.boundingClientRect.bottom <= window.innerHeight;
      isBottomVisible
        ? positioner.classList.remove("floating-cta")
        : positioner.classList.add("floating-cta");
    });
  };

  // Options and observer
  const options = {
    root: null,
    threshold: 1,
  };
  const checkoutBtnobserver = new IntersectionObserver(
    checkoutBtnCallback,
    options
  );

  checkoutBtnobserver.observe(ctaElement);
});

function submitPromo(event) {
  // event.preventDefault();

  event.target.classList.add("submitting");
  event.target.querySelector(".loading__spinner").classList.remove("hidden");

  var discountCode = document.getElementById("apply-discount").value;

  async function getDiscountCodeUrl(discountCode) {
    const shopify_features_script = document.querySelector(
      "script[id='shopify-features']"
    );
    const shopify_features_json = JSON.parse(shopify_features_script.innerHTML);

    let checkoutBtn = document.querySelector("button[type='submit'][id='checkout']")
    if(!!checkoutBtn) checkoutBtn.setAttribute("disabled", "disabled")

    const cart = await fetch(`${Shopify.routes.root}cart.js`).then((response) =>
      response.json()
    );
    const headers = {
      Authorization: "Basic " + btoa(shopify_features_json.accessToken),
      Accept: "*/*",
      "Content-Type": "application/json",
    };
    const body = {
      checkout: {
        line_items: cart.items,
        discount_code: discountCode,
        country: Shopify.country,
        presentment_currency: cart.currency,
      },
    };
    const wallet = await fetch("/wallets/checkouts/", {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
      referrerPolicy: "no-referrer",
    });
    const response = await wallet.json();
    console.log("🚀 ~ response:", response);

    if (response.checkout) {
      console.log("Valid!");
      document.cookie = `discount_code=${discountCode}; path=/`;
      let mainCartItems = document.querySelector("#main-cart-items").dataset.id;
      let mainCartFooter =
        document.querySelector("#main-cart-footer").dataset.id;
      fetch(`/discount/${discountCode}`)
        .then(function () {
          // After the discount code has been applied, force the cart to update so the discount is visible for anything that calls the .cart.json file e.g. an AJAX draw cart.
          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              updates: {},
              sections: [mainCartItems, mainCartFooter],
            }),
          });
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);

          document.querySelector(".main-cart-items").innerHTML =
            data.sections[mainCartItems];
          document.querySelector(".main-cart-footer").innerHTML =
            data.sections[mainCartFooter];
        })
        .catch(function (error) {
          console.error("Error:", error);
          event.target.classList.remove("submitting");
        })
        .finally(() => {
          event.target.classList.remove("submitting");
          event.target
            .querySelector(".loading__spinner")
            .classList.add("hidden");
        });
    } else {
      event.target.classList.remove("submitting");
      event.target.querySelector(".loading__spinner").classList.add("hidden");

      document.getElementById("promo-code-message").style.display = "block";
      console.log("not valid!");
    }

    if (response.status === 200) {
      console.log("works!");
      event.target.classList.add("submitting");
      event.target
        .querySelector(".loading__spinner")
        .classList.remove("hidden");

      return { ok: true, url: result.url };
    }

    return { ok: false };
  }

  getDiscountCodeUrl(discountCode)
    .then(() => {})
    .catch(() => {})
    .finally(() => {});
}
// document.querySelector('#discount-form button').addEventListener('click', async function (event) {

// });
